import { useEffect, useRef } from 'react';
import { tokenRefreshManager } from 'utils/lib/tokenRefreshManager';

let globalSessionInterval = null;

export function useSessionRefresher(checkIntervalMinutes = 5) {
    const intervalRef = useRef(null);

    useEffect(() => {
        if (globalSessionInterval) {
            clearInterval(globalSessionInterval);
        }

        globalSessionInterval = setInterval(async () => {
            try {
                const session = await tokenRefreshManager.getCurrentSession();
                if (tokenRefreshManager.isTokenExpired(session)) {
                    console.log('[Session] Token expired, refreshing...');
                    await tokenRefreshManager.refreshToken(true);
                } else {
                    console.log('[Session] Token still valid, skipping refresh');
                }
            } catch (error) {
                console.error('[Session] Token check failed:', error);
            }
        }, checkIntervalMinutes * 60 * 1000);

        intervalRef.current = globalSessionInterval;

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                if (globalSessionInterval === intervalRef.current) {
                    globalSessionInterval = null;
                }
            }
        };
    }, [checkIntervalMinutes]);
}